// extracted by mini-css-extract-plugin
export var avatar = "_rd-3";
export var avatarContainer = "_rd-2";
export var avatarSpacer = "_rd-5";
export var avatarSpacerContainer = "_rd-4";
export var avatarStackContainer = "_rd-1";
export var bubble = "_rd-0";
export var remainderBubble = "_rd-6";